import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [requestId, setRequestId] = useState<string | null>(null);

  useEffect(() => {
    const checkLoginRequest = async () => {
      const urlRequestId = searchParams.get('requestId');
      
      if (!urlRequestId) {
        setError('No login request ID provided');
        return;
      }

      try {
        setIsLoading(true);
        const response = await api.checkLoginRequest(urlRequestId);
        
        if (!response.valid) {
          setError(response.error || 'Invalid login request');
          return;
        }

        setRequestId(urlRequestId);
        localStorage.setItem('loginRequestId', urlRequestId);
        navigate(`/login?requestId=${urlRequestId}`);
      } catch (error) {
        console.error('Error checking login request:', error);
        setError('Failed to validate login request');
      } finally {
        setIsLoading(false);
      }
    };

    checkLoginRequest();
  }, [searchParams]);

  const handleLogin = async () => {
    if (!requestId) {
      setError('No valid login request found');
      return;
    }
    navigate(`/login?requestId=${requestId}`);
  };

  if (isLoading) {
    return (
      <div className="landing-page">
        <div className="container">
          <h1>Validating login request...</h1>
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="container">

        <div className="logo-container">
          <img src="/logo.png" alt="Logo" />
        </div>
        
        <h1>Welcome</h1>
        {/* <p>Please login to continue.</p> */}
        
        {error ? (
          <div className="error-message">
            <p>{error}</p>
            <p>Please request a new login link.</p>
          </div>
        ) : (
          <button 
            className="login-button"
            onClick={handleLogin}>
            Login with Google
          </button>
        )}
      </div>
    </div>
  );
};

export default LandingPage; 